module.exports = __webpack_public_path__ + "img/info-delivery.468c75e0.jpg";